"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
const request_builder_1 = require("./request-builder");
class Tracker {
    constructor({ user, account, universe, peopleData } = {}) {
        this.url = 'https://us-central1-stilingue-datascience.cloudfunctions.net/events-receiver';
        this.metadata = Object.assign({ userId: user === null || user === void 0 ? void 0 : user.id, userEmail: user === null || user === void 0 ? void 0 : user.email, accountId: account === null || account === void 0 ? void 0 : account.id, accountName: account === null || account === void 0 ? void 0 : account.name, universeId: universe === null || universe === void 0 ? void 0 : universe.id, universeName: universe === null || universe === void 0 ? void 0 : universe.name, hostname: window.location.hostname }, peopleData);
        this.timers = {};
    }
    track(eventName, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            const now = new Date().getTime();
            const request = new request_builder_1.RequestBuilder(eventName, Object.assign(Object.assign({}, this.metadata), metadata));
            request.validate();
            if (this.timers[eventName]) {
                request.appendEventMetadata({ duration: now - this.timers[eventName] });
                delete this.timers[eventName];
            }
            try {
                const response = yield fetch(this.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: request.toString(),
                });
                return response.ok;
            }
            catch (e) {
                return false;
            }
        });
    }
    timerFor(eventName) {
        this.timers[eventName] = new Date().getTime();
    }
}
exports.Tracker = Tracker;
